const CHECK_USER_LOGGED_IN_TIMEOUT = 0;

/* eslint-disable */
const _propagateLoginStatus = (isUserLoggedIn, usersResponse) => {
    if (isUserLoggedIn) {
        const extendedUsersResponse = Object.assign({ action: 'isPersistentLoginOk' }, usersResponse);
        Odigeo.trigger('react:fireTagManagerSuccessLoginEvent', extendedUsersResponse?.userDTO?.email);
        Odigeo.trigger('react:isUserLogged', extendedUsersResponse);
    } else {
        Odigeo.trigger('react:isUserNotLogged');
    }
};

const isOdigeoJSLoaded = () => {
    return typeof Odigeo !== 'undefined';
}

const _propagateLoginStatusToOdigeoJS = (isUserLoggedIn, usersResponse) => {
    if (isOdigeoJSLoaded()) {
        _propagateLoginStatus(isUserLoggedIn, usersResponse);
        Odigeo.bind('listenToLoginStatusChangesFromReact', () => {
            _propagateLoginStatus(isUserLoggedIn, usersResponse);
        });
    }
};

export const propagateLoginStatusToOdigeoJS = (isUserLoggedIn, usersResponse) => {
    if (!isOdigeoJSLoaded()) {
        setTimeout(() => {
            _propagateLoginStatusToOdigeoJS(isUserLoggedIn, usersResponse);
        }, CHECK_USER_LOGGED_IN_TIMEOUT);
    } else {
        _propagateLoginStatusToOdigeoJS(isUserLoggedIn, usersResponse);
    }
};

export const sendTrackingEvent = (data, type= 'trackEvent') => {
    if (isOdigeoJSLoaded()) {
            Odigeo.trigger('analytics:tracking', {
                type: type,
                data: { ...data }
            });
    }
}

export const sendTrackClickEvent = (data, type= 'trackEvent') => {
    if (isOdigeoJSLoaded()) {
        Odigeo.trigger('analytics:trackClick', {
            type: type,
            data: { ...data }
        });
    }
}

export const sendTrackComponentEvent = (data, type= 'trackEvent') => {
    if (isOdigeoJSLoaded()) {
        Odigeo.trigger('analytics:trackComponent', {
            type: type,
            data: { ...data }
        });
    }
}
